import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import styles from './quiz-section.module.scss';
import ProgressBar from 'react-bootstrap/ProgressBar';
import RightPanel from '@/components/molecules/right-panel';
import {useObservable} from '@/hooks';
import {UserObservable} from '@/observables/user.observable';
import starRewardImage from '@/assets/images/quiz/quiz_star.png';
import Checkbox from '@/components/atoms/checkbox';
import Button from '@/components/atoms/button';
import {QUIZ_START, QUIZ_ANSWER} from '@/constants/endpoints.constant';
import {useHttpGet, useHttpPost } from '@/hooks';
import Radiobutton from '@/components/atoms/radiobutton';
import {LanguageHelper} from '@/languages/helper';
import XCircle from '@/assets/icons/x-circle.svg'
/*import {useLocation} from 'react-router-dom';*/
import { LOGIN_ROUTE } from '@/constants/redirect-login';

const QuizSection = ({ isOpen, onClose, quizUuid, articleTitle, collection}) => {
    const [user] = useObservable(UserObservable.user$);
/*    const location = useLocation() || {};
    const { pathname } = location;*/
/*    const path = pathname[pathname.length - 1] === '/' ? pathname.slice(0, pathname.length - 1) : pathname;*/
    const [quiz, setQuiz] = useState({});
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(undefined);
    const { data: articleQuiz, execute: getQuiz} = useHttpGet();
    const { data: updatedQuiz, execute: submitQuizAnswer } = useHttpPost();
    const loginLink = LOGIN_ROUTE;
    const hasErrors = currentQuestion?.answers.filter((answer) => {
        return !!answer?.answer_status && answer.answer_status !== 'unselected';
    }).length > 0;
    const progress = (quiz?.completed || 0) / (quiz?.total || 1) * 100

    useEffect(() => {
        if (isOpen) {
            getQuiz(QUIZ_START(quizUuid), false);
        }
    }, [quizUuid, isOpen]);

    // on quiz start, set the quiz object
    useEffect(() => {
        if (articleQuiz) {
            setQuiz(articleQuiz);
        }
    }, [articleQuiz]);

    // any time the quiz is answered, update the state
    useEffect(() => {
        if (updatedQuiz) {
            setQuiz(updatedQuiz);
            setSelectedAnswers([]);
        }
    }, [updatedQuiz]);

    // when quiz updates, check if it has a question, and if so, if any answer has a status.
    // if not, set the currentQuestion to what was returned
    // if so, that means the question was submitted, but has a wrong answer. Instead of setting question, update the answers, maintaining the current order
    useEffect(() => {
        if (quiz && quiz.question) {
            let hasAnswerStatus = false;
            let answerStatuses = {};
            quiz.question?.answers?.forEach((answer) => {
                if (!!answer.answer_status) {
                    hasAnswerStatus = true;
                    answerStatuses[answer.uuid] = answer.answer_status;
                }
            });

            if (!hasAnswerStatus) {
                setCurrentQuestion(quiz.question);
            } else if(currentQuestion) {
                // the else if condition should always be true since you'd have to have a current question to answer it
                // but this just guarantees we don't attempt to update data that isn't set
                const updatedAnswers = currentQuestion.answers.map((answer) => {
                    return {
                        ...answer,
                        answer_status: answerStatuses[answer.uuid]
                    }
                });
                setCurrentQuestion({ ...currentQuestion, answers: updatedAnswers });
            }
        }
    }, [quiz])
    /*
    {
        "uuid": "0d75b6ee-a47f-466e-9ab1-df74561bc845",
        "quiz_uuid": "5e4bc045-809d-4160-bee9-d466a0c10c0f",
        "user_uuid": null,
        "rewards": null,
        "completed_at": null,
        "created_at": "2023-06-03T11:58:18.095411-04:00",
        "updated_at": "2023-06-03T11:58:18.095411-04:00",
        "total": 4,
        "completed": 0,
        "current": 1,
        "question": {
            "uuid": "71a62dfd-7c84-4e1d-963a-2485cfeb907f",
            "question_key": "q1q1",
            "quiz_uuid": "5e4bc045-809d-4160-bee9-d466a0c10c0f",
            "question_type": "single_choice",
            "answers": [{
                "uuid": "34606405-1f61-4728-9ff6-b6cbe5477365",
                "key": "q1q1a1",
                "label": "This is a test answer 1"
            }, {
                "uuid": "866e74dc-6685-4ef7-b530-ca1dcdd3b44c",
                "key": "q1q1a3",
                "label": "This is a test answer 3"
            }, {
                "uuid": "e4732a93-d18d-49e3-872f-512259c216d7",
                "key": "q1q1a2",
                "label": "This is a test answer 2"
            }],
            "position": 1,
            "label": "This is a test question",
            "created_at": "2023-05-31T07:30:50.103-04:00",
            "updated_at": "2023-05-31T07:30:50.103-04:00"
        }
    }
     */

    const sendUserQuestionResponse = () => {
        const payload = {
            question_uuid: currentQuestion.uuid,
            answer_uuids: selectedAnswers,
        }
        submitQuizAnswer(QUIZ_ANSWER(articleQuiz.uuid), payload);
    };

    const renderOptions = (question) => {
        switch (question?.question_type) {
            case 'single_choice':
                return question?.answers?.map((answer) => {
                    const hasError = answer.answer_status === 'incorrect';
                    const isSelected = selectedAnswers.indexOf(answer.uuid) !== -1;
                    return (
                        <div key={answer?.uuid} className={`${styles.cgQuizSection__radio}`}>
                            {!hasError ? (
                          <>
                            <Radiobutton
                                key={answer?.uuid}
                                id={`${answer?.uuid}`}
                                type='radio'
                                label={answer?.label}
                                checked={isSelected}
                                onChange={() => {
                                    if (hasErrors) {
                                        return;
                                    }
                                    if (isSelected) {
                                        setSelectedAnswers(selectedAnswers.filter((item) => item !== answer.uuid));
                                    } else {
                                        setSelectedAnswers([answer.uuid]);
                                    }
                                }}
                            >
                                <span className={styles.cgQuizSection__radioLabel}>{answer.label}</span>
                            </Radiobutton>
                          </>
                        ) : (
                        <div key={answer?.uuid} className={`${styles.cgQuizSection__radioError}`}>
                            <span className={`${styles.cgQuizSection__radioErrorCircle}`}><XCircle /></span>
                            <span className={styles.cgQuizSection__radioLabel}>{answer.label}</span>
                        </div>
                        )}
                        </div>
                    )
                  }
                );
            case 'multi_choice':
                return (
                    <>
                        <div className={`${styles.cgQuizSection__multipleChoice}`}>Select All That Apply</div>
                        <div>
                            {question?.answers?.map((answer) => {
                                const isSelected = selectedAnswers.indexOf(answer.uuid) !== -1;
                                return (<div key={answer?.uuid}>
                                    <Checkbox
                                      text={answer?.value}
                                      className={`${styles.cgQuizSection__checkbox}`}
                                      name={answer?.value}
                                      checked={isSelected}
                                      onChange={() => {
                                          if (hasErrors) {
                                              return;
                                          }
                                          if (isSelected) {
                                              setSelectedAnswers(selectedAnswers.filter((item) => item !== answer.uuid));
                                          } else {
                                              setSelectedAnswers([...selectedAnswers, answer.uuid]);
                                          }
                                      }}
                                    />
                                    <label htmlFor={answer?.uuid}>{answer?.label}</label>
                                </div>)
                            })}
                        </div>
                    </>
                );
            default:
                return <div>There was a problem with the quiz. Please try again later.</div>;
        }
    };

    const nextTryAgainButtons = () => {
        if (hasErrors) {
            return(<Button className={`${styles.cgQuizSection__tryAgain}`} onClick={() => {
                setCurrentQuestion({...quiz.question, answers: quiz.question.answers.map((answer) => {
                    if (answer.answer_status) {
                        delete answer.answer_status;
                    }
                    return answer;
                })});
            }} backgroundColor={'colors.$color-carely-blue'}>Try Again</Button>)
        }
        if (selectedAnswers.length === 0) {
            return ( <Button className={`${styles.cgQuizSection__nextDisabled}`} backgroundColor={'colors.$color-white'} disabled>Next</Button>)
        }
        return( <Button className={`${styles.cgQuizSection__next}`} backgroundColor={'colors.$color-carely-blue'} onClick={sendUserQuestionResponse}>Next</Button>)

    }

    const renderCompletedState = () => {
        if (!quiz?.completed_at) {
            return null;
        }

        let starReward = 0;
        // API allows for multiple reward types, so lets just grab the star type since that is all we care about right now
        quiz?.rewards?.forEach((reward) => {
            if (reward.reward_type === 'stars') {
                starReward = reward.reward_amount;
            }
        });

        return <div className={`${styles.cgQuizSection__congrats}`}>
            <img
              className={`${styles.cgQuizSection__star}`}
              src={starRewardImage}
              alt="Quiz Completion Star"
            />
            <div className={`${styles.cgQuizSection__congratsText}`}>Congrats!</div>
            <div className={`${styles.cgQuizSection__congratsEarned}`}>You&apos;ve earned {starReward} ★</div>
            {user ?
              (
                <>
                    <div className={`${styles.cgQuizSection__congratsSuccess}`}>Quiz completed successfully.</div>
                    { collection && <Button className={`${styles.cgQuizSection__congratsMore}`} backgroundColor={'colors.$color-carely-blue'} as='a' href={`${collection}`}>More from this collection</Button> }
                </>
              ) : (
                <>
                    <div className={`${styles.cgQuizSection__congratsSuccess}`}>Sign into your account to collect!</div>
                    <Button className={`${styles.cgQuizSection__congratsSignin}`} backgroundColor={'colors.$color-carely-blue'} as='a' href={loginLink}>{LanguageHelper('buttons.login')}</Button>
                    <div className={`${styles.cgQuizSection__congratsSignup}`}>Don’t have an account? <a className={`${styles.cgQuizSection__signupLink}`} href="/register">Sign up</a></div>
                </>
              )
            }
        </div>
    }

    const renderQuestionState = () => {
        if (!quiz?.question) {
            return null;
        }

        return <>
            <div className={`${styles.cgQuizSection__progress}`}>
                <ProgressBar now={progress} className={`${styles.cgQuizSection__progressBar}`}/>
                <div className={`${styles.cgQuizSection__progressNumber}`}>
                    {quiz.completed} / {quiz.total}
                </div>
            </div>
            <div className={`${styles.cgQuizSection__question}`}>{currentQuestion?.label}</div>
            {renderOptions(currentQuestion)}
            <div className={`${styles.cgQuizSection__button}`}>{nextTryAgainButtons()}</div>
        </>
    }

    return (
        <RightPanel isOpen={isOpen} onClose={onClose}>
            <div className={`${styles.cgQuizSection}`}>
                <div>
                <div className={`${styles.cgQuizSection__heading}`}>Test your knowledge</div>
                <div className={`${styles.cgQuizSection__articleTitle}`}>{articleTitle}</div>
                </div>
                { renderCompletedState() }
                { renderQuestionState() }
            </div>
        </RightPanel>)
}

QuizSection.propTypes = {
    quizUuid: PropTypes.string,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    articleTitle: PropTypes.string,
    collection: PropTypes.string,
}

export default QuizSection;
